import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { Link } from '../components/blocks/Link';

export const isLink = isElementType(Link);
